import { Link } from 'react-router-dom';
import { categories } from '@/mocks/articles';

const colorMap: Record<string, { bg: string; iconBg: string; text: string; border: string }> = {
  primary: {
    bg: 'bg-primary-500/8',
    iconBg: 'bg-primary-500/15',
    text: 'text-primary-400',
    border: 'border-primary-500/20',
  },
  accent: {
    bg: 'bg-accent-500/8',
    iconBg: 'bg-accent-500/15',
    text: 'text-accent-400',
    border: 'border-accent-500/20',
  },
  secondary: {
    bg: 'bg-secondary-500/8',
    iconBg: 'bg-secondary-500/15',
    text: 'text-secondary-400',
    border: 'border-secondary-500/20',
  },
};

export default function CategorySection() {
  return (
    <section className="py-14 md:py-20 bg-background-50">
      <div className="max-w-6xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-100 mb-3">
            探索分类
          </h2>
          <p className="text-sm text-foreground-500 max-w-lg mx-auto">
            从多个维度深入理解夜勤病栋，找到你最感兴趣的内容方向
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
          {categories.map((cat) => {
            const colors = colorMap[cat.color] || colorMap.primary;
            return (
              <Link
                key={cat.id}
                to={`/category/${cat.id}`}
                className={`group flex items-start gap-4 p-5 rounded-lg ${colors.bg} border ${colors.border} hover:border-opacity-60 transition-all duration-300`}
              >
                <div className={`w-11 h-11 rounded-lg ${colors.iconBg} flex items-center justify-center flex-shrink-0 group-hover:scale-110 transition-transform duration-300`}>
                  <i className={`${cat.icon} ${colors.text} text-xl`}></i>
                </div>
                <div className="min-w-0">
                  <h3 className={`font-heading text-base font-semibold ${colors.text} mb-1`}>
                    {cat.name}
                  </h3>
                  <p className="text-sm text-foreground-500 leading-relaxed mb-2">
                    {cat.description}
                  </p>
                  <span className="text-xs text-foreground-600">
                    {cat.articleCount} 篇文章
                  </span>
                </div>
              </Link>
            );
          })}
        </div>
      </div>
    </section>
  );
}